export default __webpack_public_path__ + "static/3.1-f349686ca59229eb03598f5ce494cad3.webp";